var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 4.49997C11.1 4.00292 11.503 3.59998 12 3.59998C12.4971 3.59998 12.9 4.00292 12.9 4.49998V12.6202L15.6598 9.8641C16.0108 9.51354 16.5795 9.51373 16.9302 9.86452C17.2812 10.2155 17.2812 10.7845 16.9302 11.1354L12 16.0657L7.0698 11.1354C6.71884 10.7845 6.71884 10.2155 7.0698 9.86452C7.42059 9.51373 7.98927 9.51354 8.34029 9.8641L11.1 12.6202V4.49997Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 16.5C5.59998 16.0029 6.00292 15.6 6.49998 15.6C6.99703 15.6 7.39998 16.0029 7.39998 16.5V17.6H16.6V16.5C16.6 16.0029 17.0029 15.6 17.5 15.6C17.997 15.6 18.4 16.0029 18.4 16.5V18C18.4 18.3713 18.2525 18.7274 17.9899 18.9899C17.7274 19.2525 17.3713 19.4 17 19.4H6.99998C6.62867 19.4 6.27258 19.2525 6.01003 18.9899C5.74748 18.7274 5.59998 18.3713 5.59998 18V16.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.317580b4.svg";
export { ForwardRef as ReactComponent };